import { T } from 'gt-react';
import { Link } from '@tanstack/react-router';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

interface Props {
  href: string;
  onClick?: () => void;
}

/** Outline navigation button to a notification's workflow run timeline. */
export function NotificationViewRunButton({ href, onClick }: Props) {
  return (
    <Button asChild variant="outline" size="sm">
      <Link to={href} onClick={onClick}>
        <ArrowSquareOutIcon />
        <T context="button that opens the workflow run from a notification">
          View Run
        </T>
      </Link>
    </Button>
  );
}
